import { request } from './core.api';

export interface TenantTurnoverChecklistItemDto {
  id: string;
  phase: 'Exit' | 'Entry' | string;
  step: string;
  isCompleted: boolean;
  completedAtUtc?: string | null;
}

export interface TenantTurnoverChecklistDto {
  id: string;
  propertyId: string;
  propertyAddress: string;
  title: string;
  outgoingRentalAgreementId?: string | null;
  outgoingTenantId?: string | null;
  outgoingTenantName?: string | null;
  incomingRentalAgreementId?: string | null;
  incomingTenantId?: string | null;
  incomingTenantName?: string | null;
  createdAt: string;
  updatedAt: string;
  items: TenantTurnoverChecklistItemDto[];
}

export interface CreateTenantTurnoverChecklistRequest {
  outgoingRentalAgreementId?: string;
  incomingRentalAgreementId?: string;
  title?: string;
}

export interface UpdateTenantTurnoverChecklistItemRequest {
  isCompleted: boolean;
}

export const tenantTurnoverChecklistsApi = {
  getByProperty: (propertyId: string) => request<TenantTurnoverChecklistDto[]>(`/properties/${propertyId}/tenant-turnover-checklists`),
  create: (propertyId: string, data: CreateTenantTurnoverChecklistRequest) =>
    request<TenantTurnoverChecklistDto>(`/properties/${propertyId}/tenant-turnover-checklists`, { method: 'POST', body: JSON.stringify(data) }),
  updateItem: (checklistId: string, itemId: string, data: UpdateTenantTurnoverChecklistItemRequest) =>
    request<TenantTurnoverChecklistDto>(`/tenant-turnover-checklists/${checklistId}/items/${itemId}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (checklistId: string) => request<void>(`/tenant-turnover-checklists/${checklistId}`, { method: 'DELETE' }),
};
